import { jsx as _jsx } from "react/jsx-runtime";
//src/core/context/CartContext.tsx
import { createContext, useContext, useReducer } from "react";
const initialState = {
    items: [],
};
const CartContext = createContext({
    state: initialState,
    dispatch: () => null,
});
const cartReducer = (state, action) => {
    console.log("Dispatching action:", action);
    switch (action.type) {
        case "ADD_ITEM": {
            console.log("Current state before ADD_ITEM:", state);
            const existingItemIndex = state.items.findIndex((item) => item.id === action.payload.id &&
                item.selectedColor === action.payload.selectedColor);
            if (existingItemIndex !== -1) {
                const updatedItems = state.items.map((item, index) => index === existingItemIndex
                    ? Object.assign(Object.assign({}, item), { quantity: item.quantity + action.payload.quantity }) : item);
                const newState = Object.assign(Object.assign({}, state), { items: updatedItems });
                console.log("New state after ADD_ITEM:", newState);
                return newState;
            }
            else {
                const newState = Object.assign(Object.assign({}, state), { items: [...state.items, action.payload] });
                console.log("New state after ADD_ITEM:", newState);
                return newState;
            }
        }
        case "REMOVE_ITEM":
            return Object.assign(Object.assign({}, state), { items: state.items.filter((item) => item.id !== action.payload.id) });
        case "CLEAR_CART":
            return Object.assign(Object.assign({}, state), { items: [] });
        case "UPDATE_QUANTITY":
            return Object.assign(Object.assign({}, state), { items: state.items.map((item) => item.id === action.payload.id
                    ? Object.assign(Object.assign({}, item), { quantity: action.payload.quantity }) : item) });
        default:
            return state;
    }
};
export const CartProvider = ({ children }) => {
    const [state, dispatch] = useReducer(cartReducer, initialState);
    return (_jsx(CartContext.Provider, { value: { state, dispatch }, children: children }));
};
export const useCart = () => useContext(CartContext);
